export default __webpack_public_path__ + "static/building-image-88eb096e100ab3da1c935f9b5a39ba89.jpg";